// #region Interfaces
// #endregion
export default class RoutingHelper {
    // #region Info
    getRouteInfo(url, target = '') {
        // #region Check
        if (!url) {
            return {
                mode: '',
                address: '',
            };
        }
        // #endregion
        // #region Link
        let tLink = url.toLowerCase();
        let tMode = '';
        let tAddress = '';
        //App => app://
        if (tLink.startsWith("app://")) {
            //Link
            tMode = 'app';
            tAddress = url.substr(6);
            //Optimize
            if (!tAddress.startsWith('/')) {
                tAddress = '/' + tAddress;
            }
        }
        //App => to://
        else if (tLink.startsWith("to://")) {
            //Link
            tMode = 'app';
            tAddress = url.substr(5);
            //Optimize
            if (!tAddress.startsWith('/')) {
                tAddress = '/' + tAddress;
            }
        }
        //App => action://
        else if (tLink.startsWith("action://")) {
            tMode = 'action';
            tAddress = url.substr(9);
        }
        else {
            tMode = 'link';
            tAddress = url;
        }
        // #endregion
        // #region Modal
        if (target === 'modal' && tMode === 'app') {
            tMode = 'app-modal';
        }
        // #endregion
        return {
            mode: tMode,
            address: tAddress
        };
    }
    // #endregion
    // #region Active
    isActive(currentRoute, routeToCheck) {
        // #region Check
        if (!currentRoute || currentRoute === '/') {
            return false;
        }
        if (!routeToCheck || routeToCheck === '/') {
            return false;
        }
        // #endregion
        return currentRoute.toLowerCase().startsWith(routeToCheck.toLowerCase());
    }
    hasActiveChildRoute(currentRoute, node, commandFunc, childrenMember = 'children') {
        // #region Check
        if (!node || !node[childrenMember]) {
            return false;
        }
        if (!node[childrenMember] || node[childrenMember].lenght === 0) {
            return false;
        }
        // #endregion
        // #region Run
        for (var child of node[childrenMember]) {
            //Vars
            let tAddress = commandFunc(child);
            //Children
            if (!tAddress) {
                if (this.hasActiveChildRoute(currentRoute, child, commandFunc, childrenMember)) {
                    return true;
                }
            }
            //Self
            else {
                let tInfo = utils.routing.getRouteInfo(tAddress);
                {
                    if (tInfo.mode === 'app' && utils.routing.isActive(tInfo.address, currentRoute)) {
                        return true;
                    }
                    ;
                }
            }
        }
        // #endregion
        return false;
    }
    setNodesExpanedIfHasActiveRoute(currentRoute, nodes, commandFunc, childrenMember = 'children', expanededMember = 'isExpanded') {
        nodes.forEach(tNode2 => {
            //Run
            if (tNode2[childrenMember] && tNode2[childrenMember].length > 0) {
                this.setNodesExpanedIfHasActiveRoute(currentRoute, tNode2[childrenMember], commandFunc, childrenMember, expanededMember);
            }
            //Set
            if (this.hasActiveChildRoute(currentRoute, tNode2, commandFunc, childrenMember)) {
                tNode2[expanededMember] = true;
            }
        });
    }
    // #endregion
    // #region Segements
    calculateSegement(segment) {
        let tArgs = {};
        if (segment.entity.id) {
            tArgs.id = segment.entity.id;
        }
        if (segment.navigation.mode && segment.navigation.mode !== "default") {
            tArgs.w = segment.navigation.mode;
        }
        if (segment.navigation.location) {
            tArgs.l = segment.navigation.location;
        }
        if (segment.navigation.size) {
            tArgs.s = segment.navigation.size;
        }
        if (segment.entity.mode !== "list" && segment.entity.mode !== "details") {
            tArgs.m = segment.entity.mode;
        }
        if (segment.args) {
            Object.keys(segment.args).forEach(k => {
                tArgs[k] = segment.args[k];
            });
        }
        let tData = Object.keys(tArgs).map(key => `${key}=${encodeURIComponent(tArgs[key])}`).join('&');
        {
            if (tData) {
                segment.path = segment.entity.name + ':' + tData;
            }
            else {
                segment.path = segment.entity.name;
            }
        }
    }
    getSegements(route) {
        // #region Vars
        let tSegements = [];
        let m = route;
        let tIndex = 0;
        let tEntityRoot = "";
        let tEntitySegments = [];
        // #endregion
        // #region Build
        route.params.segement?.forEach((s) => {
            // #region Vars
            let tKlammer = s.indexOf('(');
            let tDoppelpunkt = s.indexOf(':');
            let tEntity = "";
            let tArgs = "";
            // #endregion
            // #region Parser
            if (tKlammer >= 0) {
                tArgs = s.slice(tKlammer + 1);
                tEntity = s.slice(0, tKlammer);
                let tEnd = tArgs.lastIndexOf(')');
                if (tEnd >= 0) {
                    tArgs = tArgs.slice(0, tEnd);
                }
                if (tArgs.startsWith('\'')) {
                    tArgs = tArgs.slice(1);
                }
                if (tArgs.endsWith('\'')) {
                    tArgs = tArgs.slice(0, tArgs.length - 1);
                }
            }
            else if (tDoppelpunkt >= 0) {
                tArgs = s.slice(tDoppelpunkt + 1);
                tEntity = s.slice(0, tDoppelpunkt);
            }
            else {
                tEntity = s;
            }
            // #endregion
            // #region Optimize
            let tParams = utils.urlParamsToObject(tArgs);
            if (tIndex == 0) {
                tEntityRoot = tEntity;
            }
            tEntitySegments.push(tEntity);
            let tArgs1 = {};
            Object.keys(tParams).forEach(s => {
                if (s == "w" || s == "l" || s == "s" || s == "id" || s == "m") {
                    return;
                }
                tArgs1[s] = tParams[s];
            });
            // #endregion
            let tSgement = {
                path: s,
                query: tArgs,
                index: tIndex,
                ancestor: [],
                segments: {
                    path: tEntity,
                    query: tArgs
                },
                args: tArgs1,
                navigation: {
                    mode: tParams['w'] ?? 'default',
                    location: tParams['l'],
                    size: tParams['s'],
                    allowAnonymous: m.meta.allowAnonymous,
                    title: m.meta.title,
                    layout: m.meta.layout,
                    meta: m.meta,
                    isModal: false,
                    isActive: false,
                    isTest: m.meta.isTest
                },
                entity: {
                    mode: tParams.m ? tParams.m : (tParams['id'] ? 'details' : 'list'),
                    root: tEntityRoot,
                    name: tEntity,
                    segments: [...tEntitySegments],
                    id: tParams['id'],
                }
            };
            if (tSgement.navigation.mode === 'slide' || tSgement.navigation.mode === 'popup' || tSgement.navigation.mode === 'modal') {
                tSgement.navigation.isModal = true;
            }
            //Append
            tSegements.push(tSgement);
            tIndex = tIndex + 1;
        });
        // #endregion
        // #region Last
        let tLast = null;
        {
            tSegements.forEach(e => {
                if (!e.navigation.isModal) {
                    tLast = e;
                }
            });
        }
        // #endregion
        // #region Init
        //Init
        {
            if (tLast) {
                tLast.navigation.isActive = true;
            }
            if (tLast) {
                let tLastIndex = tSegements.indexOf(tLast);
                let tIndex = 0;
                tSegements.forEach(s => {
                    if (tIndex > tLastIndex && s.navigation.isModal) {
                        s.navigation.isActive = true;
                    }
                    tIndex = tIndex + 1;
                });
            }
            if (tLast?.entity) {
                let tEntityData = host.entities.rescolveComponent(tLast.entity);
                {
                    if (tEntityData?.meta) {
                        tLast.navigation.meta = { ...tLast.navigation.meta, ...tEntityData.meta };
                    }
                    if (tEntityData?.component) {
                        tLast.component = tEntityData?.component;
                    }
                }
            }
            tSegements.forEach(e => {
                if (e.navigation.isModal) {
                    let tEntityData = host.entities.rescolveComponent(e.entity);
                    {
                        if (tEntityData?.meta) {
                            e.navigation.meta = { ...e.navigation.meta, ...tEntityData.meta };
                        }
                        if (tEntityData?.component) {
                            e.component = tEntityData?.component;
                        }
                    }
                }
            });
        }
        // #endregion
        return {
            segments: tSegements,
            segmentPage: tLast
        };
    }
}
